import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { TurnoverInstitutionsModel } from './turnover-institutions.model';

export class TurnoverInstitutionsConfiguration extends ReportSectionConfigurationBase {
  typeName = 'TurnoverInstitutionsConfiguration';
  nodataLocalizationKeyName = 'turnoverInstitutions';
  readonly reportSection = ReportSection.TurnoverInstitutions;
  readonly applicableReportTypes = [ReportType.OwnershipAnalyticsReport];
  readonly reportViewModelSections = [ReportViewModelSection.OwnershipAnalyticsReport_TurnoverInstitutions];
  readonly minSize = 2;
  readonly maxSize = 4;
  readonly defaultSize = 4;
  readonly availableDataSections = [];

  get name(): string {
    if (this.appliedReportType === ReportType.OwnershipAnalyticsReport) {
      return 'turnoverInstitutions';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get displayName(): string {
    if (this.appliedReportType === ReportType.OwnershipAnalyticsReport) {
      return 'Turnover';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface TurnoverInstitutionsData {
  [ReportViewModelSection.OwnershipAnalyticsReport_TurnoverInstitutions]: TurnoverInstitutionsModel;
}
